/* Ganimarka mobile product-tile carousel — dot indicator only.
   Swiping is native CSS scroll-snap; this just reflects the active slide in
   the dots. One delegated capture-phase scroll listener handles every
   .hdt-card-carousel__track on the page, including ones added later by
   AJAX collection pagination/filtering — no per-card init, no re-scan. */
(function () {
  if (window.__gmCardCarousel) return;
  window.__gmCardCarousel = true;

  var pending = new WeakSet();

  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track || !track.classList || !track.classList.contains('hdt-card-carousel__track')) return;
    if (pending.has(track)) return;
    pending.add(track);
    requestAnimationFrame(function () {
      pending.delete(track);
      var car = track.closest('.hdt-card-carousel');
      if (!car) return;
      var dots = car.querySelectorAll('.hdt-card-carousel__dot');
      if (!dots.length) return;
      var w = track.clientWidth || 1;
      var i = Math.round(track.scrollLeft / w);
      if (i < 0) i = 0;
      if (i > dots.length - 1) i = dots.length - 1;
      for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === i);
    });
  }, true); // capture: scroll events don't bubble
})();
